module.exports = __webpack_public_path__ + "img/date.f0599ba2.png";